var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20,20H0V0H20Z","key":0}),React.createElement("path",{"d":"M60,20H40V0H60Z","key":1}),React.createElement("path",{"d":"M100,20H80V0h20Z","key":2}),React.createElement("path",{"d":"M20,60H0V40H20Z","key":3}),React.createElement("path",{"d":"M60,60H40V40H60Z","key":4}),React.createElement("path",{"d":"M100,60H80V40h20Z","key":5}),React.createElement("path",{"d":"M20,100H0V80H20Z","key":6}),React.createElement("path",{"d":"M60,100H40V80H60Z","key":7}),React.createElement("path",{"d":"M100,100H80V80h20Z","key":8})]);
}

Grid.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Grid;

Grid.default = Grid;
